import { createSlice } from '@reduxjs/toolkit';
const joyTourShowSlice = createSlice({
  name: 'joyTourShow',
  initialState: [],
  //NOTE filtersTYPE=[ {checkMode:"all",filtersMode:[ {column:"HI" , mode: "contains" , value: "helloworld"},... ]} , ... ]
  reducers: {
    stopShowingTour: (state, action) => {
      state.push(action.payload);
      return state;
    }
  }
});
export const { stopShowingTour } = joyTourShowSlice.actions;
// export const NonFilterBacklink = gridDrawerSlice.getInitialState();
export default joyTourShowSlice;
